var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["product-reviews-summary-count.j2"] = require( "product-reviews-summary-count.j2" );
dependencies["product-reviews-summary-recommendation.j2"] = require( "product-reviews-summary-recommendation.j2" );
dependencies["product-reviews-summary-fit.j2"] = require( "product-reviews-summary-fit.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-reviews-summary.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.productReviews.TotalResults",0]));
frame.set("productReviewsTotalResults", t_1, true);
if(frame.topLevel) {
context.setVariable("productReviewsTotalResults", t_1);
}
if(frame.topLevel) {
context.addExport("productReviewsTotalResults", t_1);
}
output += "\n";
var t_2;
t_2 = (lineno = 1, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.reviews.averageRating",0]));
frame.set("productReviewsAverageRating", t_2, true);
if(frame.topLevel) {
context.setVariable("productReviewsAverageRating", t_2);
}
if(frame.topLevel) {
context.addExport("productReviewsAverageRating", t_2);
}
output += "\n";
var t_3;
t_3 = (lineno = 2, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "round_step"), "round_step", context, [runtime.contextOrFrameLookup(context, frame, "productReviewsAverageRating"),10]));
frame.set("roundedAvgRating", t_3, true);
if(frame.topLevel) {
context.setVariable("roundedAvgRating", t_3);
}
if(frame.topLevel) {
context.addExport("roundedAvgRating", t_3);
}
output += "\n";
var t_4;
t_4 = "c-star-review-" + "" + env.getFilter("replace").call(context, (lineno = 3, colno = 58, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "round_step"), "round_step", context, [runtime.contextOrFrameLookup(context, frame, "productReviewsAverageRating"),2])),".","_");
frame.set("roundedAvgRatingClass", t_4, true);
if(frame.topLevel) {
context.setVariable("roundedAvgRatingClass", t_4);
}
if(frame.topLevel) {
context.addExport("roundedAvgRatingClass", t_4);
}
output += "\n\n<div class=\"o-row\">\n\n    <div class=\"o-column o-extra-small--12\">\n\n        <div class=\"c-product-reviews-summary\">\n\n            ";
env.getTemplate("product-reviews-summary-count.j2", false, "product/templates/product-reviews-summary.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n            ";
env.getTemplate("product-reviews-summary-recommendation.j2", false, "product/templates/product-reviews-summary.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\n            ";
env.getTemplate("product-reviews-summary-fit.j2", false, "product/templates/product-reviews-summary.j2", null, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_13.render(context.getVariables(), frame, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
output += t_14
output += "\n\n        </div>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-reviews-summary.j2"] , dependencies)